import { ENTITY_EMAIL_THREADS, LINK_EMAILS } from 'constants/constants';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useLinkedEmailsUrl = () => {
  const { linkedEmailsRefactor } = useFlags();

  return linkedEmailsRefactor ? ENTITY_EMAIL_THREADS : LINK_EMAILS;
};
